import React, { useEffect, useState } from "react";
import { ThreeDot } from "react-loading-indicators";
import AdsSection from "../AdsSection";

/**
 * SimilarAds component
 * 
 * Props:
 *   - adId (string): the UUID of the current item
 *   - limit (number, optional): how many similar items to fetch (default: 8)
 */
const SimilarAds = ({ slug, adId, limit = 8 }) => {
    const [similarAds, setSimilarAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!adId) return;
        const fetchSimilar = async () => {
            setLoading(true);
            setError(null);
            try {
                const resp = await fetch(
                    `${process.env.REACT_APP_API_URL}/oglas/${slug}/${adId}/similar?limit=${limit}`,
                    { credentials: 'include' }
                );
                if (!resp.ok) {
                    throw new Error(`Failed to fetch similar items: ${resp.status}`);
                }
                const data = await resp.json();
                setSimilarAds(data);
            } catch (err) {
                setError(err.message || "Unknown error");
            } finally {
                setLoading(false);
            }
        };

        fetchSimilar();
    }, [adId, limit]);

    // Map raw listing objects into AdCard-friendly shape
    const formattedAds = similarAds.map(l => ({
        id: l.id,
        images: l.images || [],
        category: l.category ? l.category.name : "Brez kategorije",
        title: l.title,
        location: l.seller && l.seller.location ? l.seller.location : {},
        price: l.price,
        created_at: l.created_at
    }));

    if (loading) {
        return <ThreeDot variant="bounce" color="#FF4367" size="medium" text="Nalaganje podobnih oglasov" textColor="#FF4367" />;
    }

    if (error) {
        return <p style={{ color: 'red' }}>Napaka: {error}</p>;
    }

    if (!formattedAds.length) {
        return <p style={{ marginTop: '1rem' }}>Trenutno ni podobnih oglasov za prikaz.</p>;
    }

    return (
        <div className="similar-items-section">
            <AdsSection title="Podobni oglasi" items={formattedAds} buttonLink={null} />
        </div>
    );
};

export default SimilarAds;